import { CLIENT_WEB_EMBEDDER_APP_NAME } from '@cp/common/clientWebEmbedding';
import { useUserAgent } from './useUserAgent';

/**
 * check app ran in embedded mode
 */
export const useIsEmbedded = (): boolean | undefined => {
  const userAgent = useUserAgent();

  if (!userAgent) {
    return;
  }

  return userAgent.endsWith(CLIENT_WEB_EMBEDDER_APP_NAME);
};
